import { HELP_CENTER_TRANSLATION_KEY } from "./faq";
const ROUTES = {
  HOME: 'HOME',
  HOME_ALTERNATIVE: 'HOME_ALTERNATIVE',
  CATEGORY: 'CATEGORY',
  SEARCH: 'SEARCH',
  SEARCH_CATEGORY: 'SEARCH_CATEGORY',
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  LOGIN: 'LOGIN',
  CHECKOUT_LOGIN: 'CHECKOUT_LOGIN',
  CHECKOUT_ADDRESSES: 'CHECKOUT_ADDRESSES',
  CHECKOUT_PAYMENT: 'CHECKOUT_PAYMENT',
  CHECKOUT_RESET_PASSWORD: 'CHECKOUT_RESET_PASSWORD',
  THANK_YOU: 'THANK_YOU',
  LANDER: 'LANDER',
  PRIVACY: 'PRIVACY',
  COOKIES: 'COOKIES',
  COMPANY_INFORMATION: 'COMPANY_INFORMATION',
  TERMS_CONDITIONS: 'TERMS_CONDITIONS',
  FAQ: 'FAQ',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  WITHDRAWAL_POLICY: 'WITHDRAWAL_POLICY',
  DISPATCH_INFORMATION: 'DISPATCH_INFORMATION',
  BATTERY_REGULATIONS: 'BATTERY_REGULATIONS',
  PREMIUM_GUARANTEE: 'PREMIUM_GUARANTEE',
  EXPONDO_PARTNERS: 'EXPONDO_PARTNERS',
  ABOUT_US: 'ABOUT_US',
  BEST_PRICES: 'BEST_PRICES',
  OUR_HISTORY: 'OUR_HISTORY',
  CAREER: 'CAREER',
  MY_ORDERS: 'MY_ORDERS',
  ACCOUNT_VERIFICATION: 'ACCOUNT_VERIFICATION',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  INSPIRATIONS: 'INSPIRATIONS',
  RECALLS: 'RECALLS',
  MERCHANT_INFORMATION: 'MERCHANT_INFORMATION',
  MY_PROFILE: 'MY_PROFILE',
  MY_NEWSLETTER: 'MY_NEWSLETTER',
  MY_EXPONDO_PARTNERS: 'MY_EXPONDO_PARTNERS',
  MY_REVIEWS: 'MY_REVIEWS',
  LOG_OUT: 'LOG_OUT',
  MY_ACCOUNT: 'MY_ACCOUNT',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  RESET_PASSWORD: 'RESET_PASSWORD',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  CHECK_EMAIL: 'CHECK_EMAIL',
  CHECKOUT_CREATE_ACCOUNT: 'CHECKOUT_CREATE_ACCOUNT',
  SHARED_BASKET: 'SHARED_BASKET',
  CHECKOUT: 'CHECKOUT',
  HIDDEN: 'HIDDEN',
  BUILD: 'BUILD',
  API: 'API',
  DISCOUNT_CODES: 'DISCOUNT_CODES',
  NEWSLETTER_CONFIRMATION: 'NEWSLETTER_CONFIRMATION',
  NEWSLETTER_CONFIRMATION_VOUCHER: 'NEWSLETTER_CONFIRMATION_VOUCHER',
  BUY_EXTRA_GUARANTEE: 'BUY_EXTRA_GUARANTEE',
};
const ROUTES_INFORMATION = {
  [ROUTES.HOME]: {
    NAME: 'home',
    SLUG: '/',
  },
  // HOME_ALTERNATIVE IS CREATED TO CAPTURE TRAFIC WHEN USERS MANUALLY ACCESS TRADITIONAL HOMEPAGE SLUG 'home'
  [ROUTES.HOME_ALTERNATIVE]: {
    NAME: 'Home Alternative',
    SLUG: '/home',
  },
  [ROUTES.SEARCH]: {
    NAME: 'search',
    SLUG: '/search',
  },
  [ROUTES.SEARCH_CATEGORY]: {
    NAME: 'search-category',
    SLUG: '/*',
  },
  [ROUTES.PRODUCT_DETAIL]: {
    NAME: 'product',
    SLUG: '/*',
  },
  [ROUTES.LOGIN]: {
    NAME: 'Login',
    SLUG: '/login',
  },
  [ROUTES.CHECKOUT_LOGIN]: {
    NAME: 'Checkout Login',
    SLUG: '/checkout/login',
  },
  [ROUTES.CHECKOUT_ADDRESSES]: {
    NAME: 'Checkout Addresses',
    SLUG: '/checkout/addresses',
  },
  [ROUTES.CHECKOUT_PAYMENT]: {
    NAME: 'Checkout Payment',
    SLUG: '/checkout/payment',
  },
  [ROUTES.CHECKOUT_RESET_PASSWORD]: {
    NAME: 'Checkout Reset Password',
    SLUG: '/checkout/password-reset',
  },
  [ROUTES.THANK_YOU]: {
    NAME: 'Thank you',
    SLUG: '/checkout/thank-you',
  },
  [ROUTES.PRIVACY]: {
    NAME: 'privacy-data',
    SLUG: '/privacy-data/',
  },
  [ROUTES.COOKIES]: {
    NAME: 'cookies',
    SLUG: '/cookies/',
  },
  [ROUTES.COMPANY_INFORMATION]: {
    NAME: 'company-information',
    SLUG: '/company-information/',
  },
  [ROUTES.TERMS_CONDITIONS]: {
    NAME: 'terms-and-conditions',
    SLUG: '/terms-and-conditions/',
  },
  [ROUTES.FAQ]: {
    NAME: 'faq',
    SLUG: HELP_CENTER_TRANSLATION_KEY,
  },
  [ROUTES.PAYMENT_METHODS]: {
    NAME: 'payment',
    SLUG: '/payment/',
  },
  [ROUTES.WITHDRAWAL_POLICY]: {
    NAME: 'withdrawal-policy',
    SLUG: '/withdrawal-policy/',
  },
  [ROUTES.DISPATCH_INFORMATION]: {
    NAME: 'dispatch-information',
    SLUG: '/dispatch-information/',
  },
  [ROUTES.BATTERY_REGULATIONS]: {
    NAME: 'battery-regulations',
    SLUG: '/battery-regulations/',
  },
  [ROUTES.PREMIUM_GUARANTEE]: {
    NAME: 'premium-guarantee',
    SLUG: '/premium-guarantee/',
  },
  [ROUTES.EXPONDO_PARTNERS]: {
    NAME: 'expondo-partners',
    SLUG: '/expondo-partners/',
  },
  [ROUTES.ABOUT_US]: {
    NAME: 'about-us',
    SLUG: 'https://corporate.expondo.com/',
  },
  [ROUTES.BEST_PRICES]: {
    NAME: 'best-prices-guaranteed',
    SLUG: '/best-prices-guaranteed/',
  },
  [ROUTES.OUR_HISTORY]: {
    NAME: 'our-history',
    SLUG: '/our-history/',
  },
  [ROUTES.CAREER]: {
    NAME: 'career',
    SLUG: 'https://corporate.expondo.com/career/',
  },
  [ROUTES.MY_ORDERS]: {
    NAME: 'My Orders',
    SLUG: '/my-account/orders',
  },
  [ROUTES.ACCOUNT_VERIFICATION]: {
    NAME: 'account-verification',
    SLUG: '/my-account/verification',
  },
  [ROUTES.VERIFY_EMAIL]: {
    NAME: 'verify-email',
    SLUG: '/email-verification/verify',
  },
  [ROUTES.INSPIRATIONS]: {
    NAME: 'inspirations',
    SLUG: '/inspirations/',
  },
  [ROUTES.RECALLS]: {
    NAME: 'product-recalls',
    SLUG: '/product-recalls/',
  },
  [ROUTES.DISCOUNT_CODES]: {
    NAME: 'discount-codes',
    SLUG: '/discount-codes/',
  },
  [ROUTES.NEWSLETTER_CONFIRMATION]: {
    NAME: 'newsletter-confirmation-crm',
    SLUG: '/newsletter-confirmation-crm/',
  },
  [ROUTES.NEWSLETTER_CONFIRMATION_VOUCHER]: {
    NAME: 'newsletter-landing-crm',
    SLUG: '/newsletter-landing-crm/',
  },
  [ROUTES.MERCHANT_INFORMATION]: {
    NAME: 'merchant-information',
    SLUG: '/merchant-information/',
  },
  [ROUTES.MY_PROFILE]: {
    NAME: 'my-profile',
    SLUG: '/my-account/my-profile',
  },
  [ROUTES.MY_NEWSLETTER]: {
    NAME: 'my-newsletter',
    SLUG: '/my-account/my-newsletter',
  },
  [ROUTES.MY_EXPONDO_PARTNERS]: {
    NAME: 'expondo-partners',
    SLUG: '/my-account/expondo-partners',
  },
  [ROUTES.MY_REVIEWS]: {
    NAME: 'my-reviews',
    SLUG: '/my-account/my-reviews',
  },
  [ROUTES.LOG_OUT]: {
    NAME: 'log-out',
    SLUG: '/log-out',
  },
  [ROUTES.MY_ACCOUNT]: {
    NAME: 'my-account',
    SLUG: '/my-account',
  },
  [ROUTES.CREATE_ACCOUNT]: {
    NAME: 'create-account',
    SLUG: '/create-account',
  },
  [ROUTES.RESET_PASSWORD]: {
    NAME: 'Reset Password Form',
    SLUG: '/password-reset',
  },
  [ROUTES.CHANGE_PASSWORD]: {
    NAME: 'change-password',
    SLUG: '/password-reset/change-password',
  },
  [ROUTES.CHECK_EMAIL]: {
    NAME: 'Check Email',
    SLUG: '/password-reset/check-email',
  },
  [ROUTES.CHECKOUT_CREATE_ACCOUNT]: {
    NAME: 'Checkout Create Account',
    SLUG: '/checkout/create-account',
  },
  [ROUTES.SHARED_BASKET]: {
    NAME: 'shared-basket',
    SLUG: '/shared-basket',
  },
  [ROUTES.BUY_EXTRA_GUARANTEE]: {
    NAME: 'buy-extra-guarantee',
    SLUG: '/buy-extra-guarantee',
  },
  [ROUTES.CHECKOUT]: {
    NAME: 'Checkout',
    SLUG: '/checkout',
  },
  [ROUTES.HIDDEN]: {
    NAME: 'Hidden Routes',
    SLUG: '/.',
  },
  [ROUTES.BUILD]: {
    NAME: 'Build Routes',
    SLUG: '/__',
  },
  [ROUTES.API]: {
    NAME: 'Api Routes',
    SLUG: '/api',
  },
};
const ROUTE_PARAMS = {
  SEARCH: {
    NEW_PRODUCTS: ['new-arrivals'],
    PRODUCTS_ON_SALE: ['sales'],
  },
};
const ABSOLUTE_ROUTE_START = '/:';
const QUERY_PARAMETER_JOINER = '&';
const QUERY_PARAMETERS_STARTER = '?';
const QUERY_PARAMETER_EQUALS = '=';
const FORBIDDEN_CHARACTERS_IN_ROUTES = ['\'', '"'];
const EXPONDO_MIDDLEWARE_ROUTES = {
  PROXY: 'expondo-middleware',
  ROOT: '/internal-api',
  SEO_REDIRECTION: '/seo-redirection',
  ADD_REVIEW: '/add-review',
  CT: {
    ROOT: '/commercetools',
    ADD_TO_CART: '/addToCart',
    APPLY_CART_COUPON: '/applyCartCoupon',
    CREATE_BANK_PAYMENT: '/createBankPayment',
    CREATE_CART: '/createCart',
    REPLICATE_CART: '/replicateCart',
    CREATE_COD_PAYMENT: '/createCodPayment',
    DELETE_CART: '/deleteCart',
    GET_CART_RECOMMENDATIONS: '/getCartRecommendations',
    GET_DISCOUNT_CODE: '/getDiscountCode',
    GET_CATEGORY: '/getCategory',
    SEARCH_PRODUCTS: '/searchProducts',
    AUTOCOMPLETE_PRODUCTS: '/autocompleteProducts',
    COUNT_PRODUCTS: '/countProducts',
    GET_ALTERNATIVE_PRODUCTS: '/getAlternativeProducts',
    GET_COMPLEMENTARY_PRODUCTS_BY_SKU: '/getComplementaryProductsBySku',
    GET_INVENTORY: '/getInventory',
    GET_ME: '/getMe',
    GET_MY_CART: '/getMyCart',
    GET_MY_FROZEN_CART: '/getMyFrozenCart',
    CUSTOMER_UPDATE_ME: '/customerUpdateMe',
    CUSTOMER_SIGN_ME_UP: '/customerSignMeUp',
    CUSTOMER_SIGN_ME_IN: '/customerSignMeIn',
    CUSTOMER_SIGN_OUT: '/customerSignOut',
    CUSTOMER_CHANGE_MY_PASSWORD: '/customerChangeMyPassword',
    GET_ORDERS: '/getOrders',
    GET_PRODUCT: '/getProduct',
    GET_PRODUCT_BY_SKU: '/getProductBySku',
    GET_REVIEW: '/getReview',
    GET_SHIPPING_METHODS_WITHOUT_ID: '/getShippingMethodsWithoutId',
    GET_VOLUME_DISCOUNTS: '/getVolumeDiscounts',
    GET_CART_DISCOUNTS_BY_KEYS: '/getCartDiscountsByKeys',
    GET_LOYALTY_LEVELS: '/getLoyaltyLevels',
    GET_PERSONALIZED_DISCOUNTS: '/getPersonalizedDiscounts',
    GET_STORES: '/getStores',
    IS_LOGGED_IN: '/isLoggedIn',
    REMOVE_CART_COUPON: '/removeCartCoupon',
    REMOVE_FROM_CART: '/removeFromCart',
    RESET_PASSWORD: '/customerResetPassword',
    UPDATE_CART_ITEM_CHANNEL: '/updateCartItemChannel',
    UPDATE_CART_QUANTITY: '/updateCartQuantity',
    UPDATE_CART: '/updateCart',
    CREATE_MY_ORDER_FROM_CART: '/createMyOrderFromCart',
    CONFIRM_EMAIL: '/confirmEmail',
  },
  ADYEN: {
    ROOT: '/adyen',
    MAKE_PAYMENT_REQUEST: '/makePaymentRequest',
    GET_PAYMENT_METHODS_REQUEST: '/getPaymentMethodsRequest',
    SUBMIT_ADDITIONAL_PAYMENT_DETAILS_REQUEST: '/submitAdditionalPaymentDetailsRequest',
  },
  FROZEN_CART: {
    ROOT: '/frozen-cart',
    FREEZE_CART: '/freezeCart',
    CREATE_CART_SESSION_TRANSFER: '/createCartSessionTransfer',
    CONSUME_CART_SESSION_TRANSFER: '/consumeCartSessionTransfer',
  },
  CMS: {
    ROOT: '/cms',
  },
  INBOUND_DATE: '/inbound-date',
  SUBMIT_CASE: '/submit-case',
};
const NATIVE_ROUTE = {
  PRODUCT: 'p',
  CATEGORY: 'c',
};
export { ROUTES };
export { ROUTES_INFORMATION };
export { ROUTE_PARAMS };
export { ABSOLUTE_ROUTE_START };
export { QUERY_PARAMETER_JOINER };
export { QUERY_PARAMETERS_STARTER };
export { QUERY_PARAMETER_EQUALS };
export { FORBIDDEN_CHARACTERS_IN_ROUTES };
export { EXPONDO_MIDDLEWARE_ROUTES };
export { NATIVE_ROUTE };
